// #region Imports
import React, { useEffect, useRef, useState } from "react"
import { useDispatch } from "react-redux"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import "react-datepicker/dist/react-datepicker.css"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { estadosFederativosOptions } from "../../constants/estadosFederativos"
import { paisesOptions } from "../../constants/paises"
import {
  Badge,
  Col,
  Row,
  Label,
  Form,
  Input,
  InputGroup,
  FormFeedback,
  UncontrolledAlert,
  UncontrolledTooltip,
} from "reactstrap"
import DropzoneComponent from "./DropzoneComponent"
import ImageWithFallback from "./ImageWithFallback"
import { useFormik } from "formik"
import * as Yup from "yup"
import avatar9 from "../../assets/images/users/avatar-9.jpg"
// #endregion

// #region selectors
import {
  useControlEscolarIsLoadingoPersona,
  useAuthPermiso,
  useControlEscolarError,
  useControlEscolaroNotificacion,
  useAuthIdPersonaAuthenticated,
  useControlEscolaroPhotoCredencial,
} from "store/selectors"
// #endregion

// #region actions
import {
  getControlEscolarGetPersona as onGetControlEscolarGetPersona,
  putControlEscolarPutPersona as onPutControlEscolarPutPersona,
  ControlEscolarUnsetError,
  ControlEscolarUnsetNotificacion,
  postControlEscolarSendPassword as onPostControlEscolarSendPassword,
  postControlEscolarUploadPhoto,
} from "../../store/actions"
import { use } from "react"
// #endregion

import { detallesAlumnoSchema } from "../../utils/validationSchemas"

const DatosGenerales = ({ idAlumno, oPersona, isEdit }) => {
  //
  // #region Init

  const optionsFlatpickr = {
    locale: Spanish,
    altInput: true,
    dateFormat: "Y-m-d",
    enableTime: false,
  }
  // #endregion

  // #region const-selectors
  const isAdministradorGeneral = useAuthPermiso(["sis_administrador_general"])
  const notificacion = useControlEscolaroNotificacion()
  const error = useControlEscolarError()
  const idPersonaAuthenticated = useAuthIdPersonaAuthenticated()
  const oPhotoCredencial = useControlEscolaroPhotoCredencial()
  const isLoading = useControlEscolarIsLoadingoPersona()
  // #endregion selectors

  // #region useRef
  const flatpickrRef = useRef(null)
  // #endregion

  // #region Options

  const estadosCiviles = [
    { value: 1, label: "Soltero" },
    { value: 2, label: "Casado" },
    { value: 3, label: "Divorciado" },
    { value: 4, label: "Union Libre" },
    { value: 5, label: "Viudo" },
  ]
  // #endregion

  // #region react-redux
  const dispatch = useDispatch()
  // #endregion

  // #region Internal States
  const [showPassword, setShowPassword] = useState(false)
  const [showDropZone, setShowDropZone] = useState(false)
  const [userImageUrl, setUserImageUrl] = useState(
    "https://avatar.iran.liara.run/public"
  )
  const [show, setShow] = useState(false)
  // #endregion

  // #region useEffects

  useEffect(() => {
    if (isLoading) {
      setUserImageUrl(avatar9)
    }
  }, [isLoading])

  useEffect(() => {
    //console.log("oPersona", oPersona)
    formik.setTouched({
      Apellido_Paterno: true,
      Nombres: true,
      Curp: true,
      Email_Personal: true,
      Password: true,
      Telefono_Celular: true,
      Ciudad_Nacimiento: true,
      id_Estado: true,
      id_Pais: true,
      Fecha_Nacimiento: true,
      id_Estado_Civil: true,
      Sexo: true,
    })
    formik.validateForm()
    if (oPersona && oPersona.url_Photo) {
      //console.log("oPersona.Curp:", oPersona.Curp)
      //console.log("oPersona.url_Photo:", oPersona.url_Photo)
      setUserImageUrl(oPersona.url_Photo)
    } else {
      if (oPersona && oPersona.Sexo_Masculino) {
        setUserImageUrl("https://avatar.iran.liara.run/public/boy")
      } else {
        setUserImageUrl("https://avatar.iran.liara.run/public/girl")
      }
    }
  }, [oPersona])

  useEffect(() => {
    //console.log("useEffect::oPhotoCredencial: ", oPhotoCredencial)
    if (oPhotoCredencial && oPhotoCredencial.size > 0) {
      setShowDropZone(false)
      dispatch(
        onGetControlEscolarGetPersona({
          nombreSolicitud: "getopersona",
          idAlumno: idAlumno,
        })
      )
    }
  }, [oPhotoCredencial])

  useEffect(() => {
    if (notificacion && notificacion.length) {
      toast.success(notificacion, {
        autoClose: 2000,
      })
      dispatch(ControlEscolarUnsetNotificacion())
    }
  }, [dispatch, notificacion])

  // #endregion

  // #region functions
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  const toggleDropZoneVisibility = () => {
    setShowDropZone(!showDropZone)
  }

  const handlerOnClickSendPassword = e => {
    //console.log("Enviar password")
    dispatch(
      onPostControlEscolarSendPassword({
        nombreSolicitud: "sendpassword",
        idAlumno: idAlumno,
        idPersona: idPersonaAuthenticated,
      })
    )
  }

  const handleDropAccepted = ({ formData, base64Files, identificator }) => {
    const updatedFormData = new FormData()
    let hasFile = false

    for (let [key, value] of formData.entries()) {
      if (key === "file") {
        hasFile = true

        // Cambia el nombre del archivo
        const renamedFile = new File([value], formik.values.Curp + ".jpg", {
          type: value.type,
          lastModified: value.lastModified,
        })

        // Agrega el archivo renombrado al nuevo FormData
        updatedFormData.append("file", renamedFile)
      } else {
        // Copia otros datos al nuevo FormData si es necesario
        updatedFormData.append(key, file)
      }
    }

    if (hasFile && formik.values.Curp.length == 18) {
      //dispatch(postControlEscolarUploadPhoto({ formData }))
      dispatch(
        postControlEscolarUploadPhoto(
          {
            nombreSolicitud: "uploadphotocredencial",
            idAlumno: idAlumno,
            idPersona: idPersonaAuthenticated,
          },
          updatedFormData
        )
      )
      toggleDropZoneVisibility()
    } else {
      if (formik.values.Curp.length !== 18) {
        toast.error("El Curp debe ser válido.", {
          autoClose: 2000,
        })
      } else {
        toast.error("Error: Nada que subir.", {
          autoClose: 2000,
        })
      }
      console.error("formData está vacío o no contiene el archivo esperado.")
    }
  }
  // #endregion

  //#region Formik form

  const {
    id_Persona = -1,
    Apellido_Paterno = "",
    Apellido_Materno = "",
    Nombres = "",
    Curp = "",
    Email_Personal = "",
    Password = "",
    Telefono_Celular = "",
    Ciudad_Nacimiento = "",
    id_Estado = "",
    id_Pais = "",
    Fecha_Nacimiento = "",
    id_Estado_Civil = "",
    Sexo_Masculino,
  } = oPersona

  const initialValues = {
    id_Persona,
    Apellido_Paterno,
    Apellido_Materno,
    Nombres,
    Curp,
    Email_Personal,
    Password,
    Telefono_Celular,
    Ciudad_Nacimiento,
    id_Estado,
    id_Pais,
    Fecha_Nacimiento: Fecha_Nacimiento.split("T")[0],
    id_Estado_Civil,
    Sexo: Sexo_Masculino ? 1 : 0,
  }

  const onSubmit = values => {
    //console.log("Form data", values)
    dispatch(
      onPutControlEscolarPutPersona({
        nombreSolicitud: "updatepersona",
        oPersona: values,
        idAlumno: idAlumno,
        idPersona: idPersonaAuthenticated,
      })
    )
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: detallesAlumnoSchema,
    onSubmit: onSubmit,
    enableReinitialize: true,
  })

  const handleUpperCaseChange = event => {
    // Obtiene el nombre del campo y el valor en mayúsculas
    const name = event.target.name
    const value = event.target.value.toUpperCase()

    // Utiliza Formik para actualizar el valor
    formik.setFieldValue(name, value)
  }

  const handleLowerCaseChange = event => {
    // Obtiene el nombre del campo y el valor en mayúsculas
    const name = event.target.name
    const value = event.target.value.toLowerCase()

    // Utiliza Formik para actualizar el valor
    formik.setFieldValue(name, value)
  }

  // #endregion

  return (
    <React.Fragment>
      {/* {//console.log("formik.touched: ", formik.touched)}
      {//console.log("formik.errors: ", formik.errors)}
      {//console.log("formik.isValid: ", formik.isValid)}
      {//console.log("isAdministradorGeneral: ", isAdministradorGeneral)} */}
      <ToastContainer />
      <DropzoneComponent
        onDropAccepted={handleDropAccepted}
        isOpen={showDropZone}
        maxFiles={1}
      />
      <Form onSubmit={formik.handleSubmit}>
        <Row>
          <div id="liveAlertPlaceholder">
            <UncontrolledAlert
              color="danger"
              role="alert"
              isOpen={show}
              toggle={() => {
                setShow(false)
              }}
            >
              A simple danger alert—check it out!
            </UncontrolledAlert>
          </div>
        </Row>
        {/* 1er Row Apellido_Paterno && Curp */}
        <Row>
          <Col md={10}>
            {/* Apellido_Paterno, Apellido_Materno, Nombres */}
            <Row>
              <Col md={4}>
                {" "}
                <div className="mb-3">
                  <Label htmlFor="formrow-Apellido_Paterno-Input">
                    * Apellido Paterno
                  </Label>
                  {!isLoading ? (
                    <Input
                      type="text"
                      name="Apellido_Paterno"
                      className="form-control"
                      id="formrow-Apellido_Paterno-Input"
                      placeholder="Apellido Paterno"
                      autoComplete="off"
                      value={formik.values.Apellido_Paterno}
                      onChange={handleUpperCaseChange}
                      onBlur={formik.handleBlur}
                      readOnly={!isAdministradorGeneral}
                      invalid={
                        formik.touched.Apellido_Paterno &&
                        formik.errors.Apellido_Paterno
                          ? true
                          : false
                      }
                    />
                  ) : (
                    <div>
                      <p aria-hidden="true" className="mt-2">
                        <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                      </p>
                    </div>
                  )}
                  {formik.errors.Apellido_Paterno &&
                  formik.touched.Apellido_Paterno ? (
                    <FormFeedback type="invalid">
                      {formik.errors.Apellido_Paterno}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col md={4}>
                {" "}
                <div className="mb-3">
                  <Label htmlFor="formrow-Apellido_Materno-Input">
                    * Apellido Materno
                  </Label>
                  {!isLoading ? (
                    <Input
                      type="text"
                      name="Apellido_Materno"
                      className="form-control"
                      id="formrow-Apellido_Materno-Input"
                      placeholder="Apellido Materno"
                      autoComplete="off"
                      readOnly={!isAdministradorGeneral}
                      value={formik.values.Apellido_Materno}
                      onChange={handleUpperCaseChange}
                      onBlur={formik.handleBlur}
                      invalid={
                        formik.touched.Apellido_Materno &&
                        formik.errors.Apellido_Materno
                          ? true
                          : false
                      }
                    />
                  ) : (
                    <div>
                      <p aria-hidden="true" className="mt-2">
                        <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                      </p>
                    </div>
                  )}

                  {formik.errors.Apellido_Materno &&
                  formik.touched.Apellido_Materno ? (
                    <FormFeedback type="invalid">
                      {formik.errors.Apellido_Materno}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col md={4}>
                {" "}
                <div className="mb-3">
                  <Label htmlFor="formrow-Nombres-Input">* Nombre(s)</Label>
                  {!isLoading ? (
                    <Input
                      type="text"
                      name="Nombres"
                      className="form-control"
                      id="formrow-Nombres-Input"
                      placeholder="Nombre de pila"
                      autoComplete="off"
                      readOnly={!isAdministradorGeneral}
                      value={formik.values.Nombres}
                      onChange={handleUpperCaseChange}
                      onBlur={formik.handleBlur}
                      invalid={
                        formik.touched.Nombres && formik.errors.Nombres
                          ? true
                          : false
                      }
                    />
                  ) : (
                    <div>
                      <p aria-hidden="true" className="mt-2">
                        <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                      </p>
                    </div>
                  )}

                  {formik.errors.Nombres && formik.touched.Nombres ? (
                    <FormFeedback type="invalid">
                      {formik.errors.Nombres}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
            </Row>
            {/* Curp, Email, Password */}
            <Row>
              <Col md={4}>
                {" "}
                <div className="mb-3">
                  <Label htmlFor="formrow-Curp-Input">* CURP</Label>
                  {!isLoading ? (
                    <Input
                      type="text"
                      name="Curp"
                      className="form-control"
                      id="formrow-Curp-Input"
                      placeholder="Curp"
                      readOnly={!isAdministradorGeneral}
                      value={formik.values.Curp}
                      onChange={handleUpperCaseChange}
                      onBlur={formik.handleBlur}
                      invalid={
                        formik.touched.Curp && formik.errors.Curp ? true : false
                      }
                    />
                  ) : (
                    <div>
                      <p aria-hidden="true" className="mt-2">
                        <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                      </p>
                    </div>
                  )}

                  {formik.errors.Curp && formik.touched.Curp ? (
                    <FormFeedback type="invalid">
                      {formik.errors.Curp}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-3">
                  <Label htmlFor="formrow-Email_Personal-Input">* Email</Label>
                  {!isLoading ? (
                    <Input
                      type="email"
                      name="Email_Personal"
                      className="form-control"
                      id="formrow-Email_Personal-Input"
                      placeholder="Escribe tu Email_Personal"
                      autoComplete="off"
                      value={formik.values.Email_Personal}
                      onChange={handleLowerCaseChange}
                      onBlur={formik.handleBlur}
                      invalid={
                        formik.touched.Email_Personal &&
                        formik.errors.Email_Personal
                          ? true
                          : false
                      }
                    />
                  ) : (
                    <div>
                      <p aria-hidden="true" className="mt-2">
                        <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                      </p>
                    </div>
                  )}

                  {formik.errors.Email_Personal &&
                  formik.touched.Email_Personal ? (
                    <FormFeedback type="invalid">
                      {formik.errors.Email_Personal}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-3">
                  <Label htmlFor="formrow-Password-Input">
                    * Password{" "}
                    {formik.isValid ? (
                      <>
                        <i
                          onClick={handlerOnClickSendPassword}
                          className="bx bx-mail-send"
                          id="viewtooltip_send_password"
                        ></i>
                        <UncontrolledTooltip
                          key={"Send"}
                          delay={1000}
                          autohide={true}
                          placement="top"
                          target="viewtooltip_send_password"
                        >
                          Enviar Password
                        </UncontrolledTooltip>
                      </>
                    ) : null}
                  </Label>

                  {!isLoading ? (
                    <>
                      <div className="input-group">
                        <Input
                          type={showPassword ? "text" : "password"}
                          name="Password"
                          className="form-control"
                          id="formrow-Password-Input"
                          placeholder="Escribe el password"
                          autoComplete="off"
                          value={formik.values.Password}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={
                            formik.touched.Password && formik.errors.Password
                              ? true
                              : false
                          }
                        />{" "}
                        <div
                          className="input-group-text"
                          style={{ cursor: "pointer" }}
                          onClick={togglePasswordVisibility}
                        >
                          <i
                            className={`fas ${
                              showPassword ? "fa-eye-slash" : "fa-eye"
                            }`}
                          ></i>
                        </div>
                        {formik.errors.Password && formik.touched.Password ? (
                          <FormFeedback type="invalid">
                            {formik.errors.Password}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </>
                  ) : (
                    <p aria-hidden="true" className="mt-2">
                      <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                    </p>
                  )}
                </div>
              </Col>
            </Row>
          </Col>

          {/* Foto */}
          <Col md={2}>
            {" "}
            <div className="text-center">
              {/* {//console.log("userImageUrl:", userImageUrl)} */}
              {/* <ImageWithFallback
                imageUrl={userImageUrl}
                fallbackImage={avatar5}
                className={"avatar-xl rounded d-block mx-auto"}
              /> */}
              {!isLoading ? (
                <img
                  src={userImageUrl}
                  // style={{
                  //   width: "256px",
                  //   height: "256px",
                  //   objectFit: "none", // No ajustar la imagen
                  //   objectPosition: "center", // Mostrar el centro de la imagen
                  //   overflow: "hidden", // Ocultar contenido que sobresalga
                  // }}
                  alt=""
                  className="avatar-xl rounded d-block mx-auto" //className="avatar-xxl rounded position-relative z-n1"
                />
              ) : (
                <img
                  src={avatar9}
                  alt=""
                  className="avatar-xl rounded d-block mx-auto" //className="avatar-xxl rounded position-relative z-n1"
                />
              )}
              {/* <img
                src={userImageUrl}
                alt=""
                className="avatar-xl rounded d-block mx-auto" //className="avatar-xxl rounded position-relative z-n1"
              /> */}
              <Row className="icon-demo-content">
                <Col>{/* <i className="bx bx-camera"></i> */}</Col>
                <Col>
                  <Badge
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={toggleDropZoneVisibility}
                    color="primary"
                    className={`${
                      showDropZone ? null : "badge-soft-info"
                    } me-2`}
                  >
                    Subir
                  </Badge>
                </Col>
              </Row>
              {/* <i className="bx bxs-file-jpg"></i> */}
            </div>
          </Col>
        </Row>

        {/* Género, Telefono Celular, Estado Civil */}
        <Row>
          <Col md={3}>
            <div className="mb-3">
              <Label className="d-block mb-3">* Género </Label>
              {!isLoading ? (
                <>
                  <div className="form-check form-check-inline">
                    <Input
                      type="radio"
                      id="customRadioInline1"
                      className="form-check-input"
                      name="Sexo"
                      value="Masculino"
                      checked={formik.values.Sexo === 1}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="customRadioInline1"
                    >
                      Masculino
                    </label>
                  </div>
                  &nbsp;
                  <div className="form-check form-check-inline">
                    <Input
                      type="radio"
                      className="form-check-input"
                      id="customRadioInline2"
                      name="Sexo"
                      value="Femenino"
                      checked={formik.values.Sexo === 0}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="customRadioInline2"
                    >
                      Femenino
                    </label>
                  </div>
                  <div>
                    {formik.errors.Sexo && formik.touched.Sexo ? (
                      <FormFeedback type="invalid">
                        {formik.errors.Sexo}
                      </FormFeedback>
                    ) : null}
                  </div>
                </>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
            </div>
          </Col>
          <Col md={3}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-Telefono_Celular-Input">
                * Telefono Celular
              </Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="Telefono_Celular"
                  className="form-control"
                  id="formrow-Telefono_Celular-Input"
                  placeholder="Número de celular"
                  autoComplete="off"
                  value={formik.values.Telefono_Celular}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.Telefono_Celular &&
                    formik.errors.Telefono_Celular
                      ? true
                      : false
                  }
                />
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}

              {formik.errors.Telefono_Celular &&
              formik.touched.Telefono_Celular ? (
                <FormFeedback type="invalid">
                  {formik.errors.Telefono_Celular}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
          <Col md={4}>
            <div className="mb-3">
              <Label htmlFor="formrow-InputEstado_Civil">Estado Civil</Label>
              {!isLoading ? (
                <select
                  name="id_Estado_Civil"
                  id="formrow-InputEstado_Civil"
                  className="form-control"
                  value={formik.values.id_Estado_Civil}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value={-1}>Elige...</option>
                  {estadosCiviles.map(option => {
                    return (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    )
                  })}
                </select>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.id_Estado_Civil &&
              formik.touched.id_Estado_Civil ? (
                <span className="text-danger">
                  {formik.errors.id_Estado_Civil}
                </span>
              ) : null}
            </div>
          </Col>
        </Row>

        {/* Ciudad Nacimiento, Estado, Pais */}
        <Row>
          <Col lg={4}>
            <div className="mb-3">
              <Label htmlFor="formrow-InputCity">Ciudad de Nacimiento</Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="city"
                  className="form-control"
                  id="formrow-InputCity"
                  placeholder="Ciudad de nacimiento"
                  autoComplete="off"
                  value={formik.values.city}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.city && formik.errors.city ? true : false
                  }
                />
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}

              {formik.errors.city && formik.touched.city ? (
                <FormFeedback type="invalid">{formik.errors.city}</FormFeedback>
              ) : null}
            </div>
          </Col>
          <Col lg={4}>
            <div className="mb-3">
              <Label htmlFor="formrow-InputEstado">* Estado Nacimiento</Label>
              {!isLoading ? (
                <select
                  name="id_Estado"
                  id="formrow-InputEstado"
                  className="form-control"
                  value={formik.values.id_Estado}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value={-1}>Elige...</option>
                  {estadosFederativosOptions.map(option => {
                    return (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    )
                  })}
                </select>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.id_Estado && formik.touched.id_Estado ? (
                <span className="text-danger">{formik.errors.id_Estado}</span>
              ) : null}
            </div>
          </Col>

          <Col lg={4}>
            <div className="mb-3">
              <Label htmlFor="formrow-id_Pais">* País de Nacimiento</Label>
              {!isLoading ? (
                <select
                  name="id_Pais"
                  id="formrow-InputState"
                  className="form-control"
                  value={formik.values.id_Pais}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value={-1}>Elige...</option>
                  {paisesOptions.map(option => {
                    return (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    )
                  })}
                </select>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.id_Pais && formik.touched.id_Pais ? (
                <FormFeedback type="invalid">
                  {formik.errors.id_Pais}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
        </Row>

        {/* Fecha Nacimiento */}
        <Row>
          <Col lg={4}>
            <div className="mb-3">
              <Label htmlFor="formrow-Fecha_Nacimiento">
                * Fecha de Nacimiento
              </Label>
              {!isLoading ? (
                <InputGroup>
                  <Flatpickr
                    ref={flatpickrRef}
                    options={optionsFlatpickr}
                    name="formrow-Fecha_Nacimiento"
                    className="form-control d-block"
                    id="formrow-Fecha_Nacimiento"
                    placeholder="Fecha de nacimiento"
                    value={formik.values.Fecha_Nacimiento}
                    onChange={(selectedDates, dateStr, instance) => {
                      formik.setFieldValue("Fecha_Nacimiento", dateStr)
                    }}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.Fecha_Nacimiento &&
                      formik.errors.Fecha_Nacimiento
                        ? true
                        : false
                    }
                  />
                </InputGroup>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.Fecha_Nacimiento &&
              formik.touched.Fecha_Nacimiento ? (
                <FormFeedback type="invalid">
                  {formik.errors.Fecha_Nacimiento}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
        </Row>

        <div className="d-flex justify-content-end mt-2">
          {isEdit ? (
            <button
              type="submit"
              className="btn btn-primary w-md"
              disabled={!formik.isValid || !isAdministradorGeneral}
            >
              Enviar
            </button>
          ) : null}
          {/* <button
            type="button"
            className="btn btn-primary"
            onClick={() => setShow(true)}
            id="liveAlertBtn"
          >
            Show live alert
          </button> */}
        </div>
      </Form>
    </React.Fragment>
  )
}

export default DatosGenerales
